// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3YJBg","dragIcon":"SortableItem_dragIcon__1ebf1","disabled":"SortableItem_disabled__2X1Xl"};